import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout/layout.component';
import { NotfoundComponent } from './components/404/404.component';
import { AuthGuard } from './guards/auth.guard';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: LayoutComponent,
                children: [
                    { path: '', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule) },
                    { path: 'user', loadChildren: () => import('./pages/user/user.module').then(m => m.UserModule) },
                    { path: 'historico', loadChildren: () => import('./pages/historico/historico.module').then(m => m.HistoricoModule) },
                    { path: 'detail/:id', loadChildren: () => import('./pages/puntal-config/puntal-config.module').then(m => m.PuntalConfigModule) },
                ],
                canActivate: [AuthGuard]
            },
            // { path: 'auth', loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule) },
            {
                path: 'auth',
                loadChildren: () =>
                    import('./pages/auth/auth.module').then((m) => m.AuthModule),
            },
            {
                path: 'notfound', component: NotfoundComponent
            },
            { path: '**', redirectTo: 'notfound' },
            
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
